import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiDataLabelValues = async() => {
    if( !checkPermission('getApiDataLabelValues', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data/label/values`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiDataQueryRange = async(query, start,  end,  step) => {
    if( !checkPermission('getApiDataQueryRange', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data/query/range?query=${query}&start=${start}&end=${end}&step=${step}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiDataQuery = async(query, timeStamp) => {
    if( !checkPermission('getApiDataQuery', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/data/query?query=${query}&time=${timeStamp}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}